module.exports = __webpack_public_path__ + "img/QR.a72dd706.png";